import secureLocalStorage from "react-secure-storage";

export const getLocalStorageItem = (key) => {
  const itemValue = secureLocalStorage.getItem(key);
  return itemValue && itemValue !== "undefined" ? JSON.parse(itemValue) : "";
};
